import { Title } from '@angular/platform-browser';
import { UserDivision } from './shared/types';
import { Injectable } from '@angular/core';

const WMG_TITLE = 'Warner Music Group: Sync Licensing';
const WCM_TITLE = 'Warner Chappell Music: Sync Licensing';

type PitchTitles = { [key in UserDivision]: string };

const titles: PitchTitles = {
  WCM: WCM_TITLE,
  WMG: WMG_TITLE,
  WCM_WMG: WMG_TITLE,
  WMG_WCM: WMG_TITLE
};

@Injectable({
  providedIn: 'root'
})
export class PitchTitleService {
  constructor(private titleService: Title) {}

  public setTitle(division: UserDivision): void {
    const title = titles[division];
    this.titleService.setTitle(title);
  }
}
